import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "pt-10" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "pt-10" }
const _hoisted_7 = { class: "pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_mail_table_container = _resolveComponent("mail-table-container")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_chat_detail_dialog = _resolveComponent("chat-detail-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { value: "一斉メッセージ" }),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        to: "/mail/new"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[18] || (_cache[18] = _createTextVNode(" 新規作成 ", -1))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_alert, {
      class: "my-4",
      type: "info",
      color: "primary",
      variant: "outlined",
      density: "compact",
      style: {"font-size":"0.9rem"}
    }, {
      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
        _createTextVNode(" ここで送信されたメッセージは、モバイルアプリ「CCS」の一斉メッセージで作成されたメールと同様に、保護者用アプリ「CCS HOME」のチャット画面に送信されます。", -1),
        _createElementVNode("br", null, null, -1),
        _createTextVNode(" 以下に表示されている一覧画面には、当画面から送信されたメッセージとモバイルアプリから送信されたメッセージの両方が表示されています。 ", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "delivered" }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
            _createTextVNode("配信済み", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "inProgress" }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
            _createTextVNode("配信中", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "inDraft" }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
            _createTextVNode("下書き", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "delivered" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "flat",
              elevation: "2",
              class: "mt-6 pa-2",
              color: "grey-lighten-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { fluid: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "pb-4" }, "日付で絞り込み", -1)),
                            _createVNode(_component_date_picker, {
                              modelValue: _ctx.startedAtFilterValue,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startedAtFilterValue) = $event)),
                              label: "開始日"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "pb-4" }, [
                              _createElementVNode("br")
                            ], -1)),
                            _createVNode(_component_date_picker, {
                              modelValue: _ctx.endedAtFilterValue,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endedAtFilterValue) = $event)),
                              label: "終了日"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "pb-4" }, [
                              _createElementVNode("br")
                            ], -1)),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.titleFilterValue,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.titleFilterValue) = $event)),
                              label: "タイトル検索",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _cache[26] || (_cache[26] = _createElementVNode("div", null, "送信者", -1)),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.userIdFilterValue,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userIdFilterValue) = $event)),
                              items: _ctx.staffOptionsList,
                              "item-title": "title",
                              "item-value": "userId",
                              variant: "outlined",
                              "hide-details": "",
                              clearable: "",
                              density: "compact",
                              color: "primary"
                            }, {
                              selection: _withCtx(({ item }) => [
                                (item.value !== 'all')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.title), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_mail_table_container, {
                onClick: _ctx.clickDetail,
                onDelete: _ctx.deleteGroupChat,
                chats: _ctx.groupChats,
                loading: _ctx.loading
              }, null, 8, ["onClick", "onDelete", "chats", "loading"]),
              _createVNode(_component_v_pagination, {
                class: "pt-4",
                modelValue: _ctx.page,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page) = $event)),
                  _ctx.pageClick
                ],
                length: Math.ceil(_ctx.totalItemsCount / _ctx.limit),
                "active-color": "primary"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "length"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "inProgress" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "flat",
              elevation: "2",
              class: "mt-6 pa-2",
              color: "grey-lighten-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { fluid: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "pb-4" }, "日付で絞り込み", -1)),
                            _createVNode(_component_date_picker, {
                              modelValue: _ctx.startedAtFilterValue,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startedAtFilterValue) = $event)),
                              label: "開始日",
                              color: "primary"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "pb-4" }, [
                              _createElementVNode("br")
                            ], -1)),
                            _createVNode(_component_date_picker, {
                              modelValue: _ctx.endedAtFilterValue,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endedAtFilterValue) = $event)),
                              label: "終了日",
                              color: "primary"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "pb-4" }, [
                              _createElementVNode("br")
                            ], -1)),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.titleFilterValue,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.titleFilterValue) = $event)),
                              label: "タイトル検索",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _cache[30] || (_cache[30] = _createElementVNode("div", null, "送信者", -1)),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.userIdFilterValue,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userIdFilterValue) = $event)),
                              items: _ctx.staffOptionsList,
                              "item-title": "title",
                              "item-value": "userId",
                              variant: "outlined",
                              "hide-details": "",
                              clearable: "",
                              density: "compact",
                              color: "primary"
                            }, {
                              selection: _withCtx(({ item }) => [
                                (item.value !== 'all')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.title), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_mail_table_container, {
                onClick: _ctx.clickDetail,
                onDelete: _ctx.deleteGroupChat,
                chats: _ctx.groupChats,
                loading: _ctx.loading
              }, null, 8, ["onClick", "onDelete", "chats", "loading"]),
              _createVNode(_component_v_pagination, {
                class: "pt-4",
                modelValue: _ctx.page,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.page) = $event)),
                length: Math.ceil(_ctx.totalItemsCount / _ctx.limit),
                "active-color": "primary"
              }, null, 8, ["modelValue", "length"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "inDraft" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "flat",
              elevation: "2",
              class: "mt-6 pa-2",
              color: "grey-lighten-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, { fluid: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "pb-4" }, "日付で絞り込み", -1)),
                            _createVNode(_component_date_picker, {
                              modelValue: _ctx.startedAtFilterValue,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startedAtFilterValue) = $event)),
                              label: "開始日"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "pb-4" }, [
                              _createElementVNode("br")
                            ], -1)),
                            _createVNode(_component_date_picker, {
                              modelValue: _ctx.endedAtFilterValue,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endedAtFilterValue) = $event)),
                              label: "終了日"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, { cols: "4" }, {
                          default: _withCtx(() => [
                            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "pb-4" }, [
                              _createElementVNode("br")
                            ], -1)),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.titleFilterValue,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.titleFilterValue) = $event)),
                              label: "タイトル検索",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              color: "primary"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_mail_table_container, {
                loading: _ctx.loading,
                onClick: _ctx.clickDetail,
                onDelete: _ctx.deleteGroupChat,
                chats: _ctx.drafts
              }, null, 8, ["loading", "onClick", "onDelete", "chats"]),
              _createVNode(_component_v_pagination, {
                class: "pt-4",
                modelValue: _ctx.page,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.page) = $event)),
                length: Math.ceil(_ctx.totalItemsCount / _ctx.limit),
                "active-color": "primary"
              }, null, 8, ["modelValue", "length"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_chat_detail_dialog, {
      isOpen: _ctx.dialog,
      onIsOpen: _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialog = $event)),
      chat: _ctx.chatDetail,
      isDraft: _ctx.tab == 'inDraft'
    }, null, 8, ["isOpen", "chat", "isDraft"])
  ]))
}